<div class="inner-content">
    <div class="wrapper">

        <div class="wrapper-program">

            <div class="title">
                {{ notification.title }}
            </div>

            <div class="text" [innerHTML]="notification.body"></div>

            <div class="image" *ngIf="notification.image">
                <img [src]="notification.image" alt="">
            </div>

            <div class="buttons" *ngIf="notification.buttons && notification.buttons.length > 0">

                <button *ngFor="let button of notification.buttons"
                        type="button"
                        (click)="onButtonClick(button)"
                        class="btn btn-green"
                >
                    {{ button.title }}
                </button>

            </div>

        </div>


        <div class="close" (click)="close()">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M8.26035 8.26035C8.60748 7.91322 9.1703 7.91322 9.51743 8.26035L16 14.743L22.4826 8.26041C22.8297 7.91327 23.3925 7.91327 23.7396 8.26041C24.0868 8.60754 24.0868 9.17035 23.7397 9.51749L17.2571 16L23.7396 22.4825C24.0867 22.8296 24.0867 23.3925 23.7396 23.7396C23.3925 24.0867 22.8296 24.0867 22.4825 23.7396L16 17.2571L9.51749 23.7397C9.17036 24.0868 8.60754 24.0868 8.26041 23.7397C7.91328 23.3925 7.91328 22.8297 8.26041 22.4826L14.7429 16L8.26035 9.51743C7.91322 9.1703 7.91322 8.60748 8.26035 8.26035Z"
                      fill="#83B25F"/>
            </svg>
        </div>


    </div>
</div>



